const factor = 3;

export const getMaxWidth = () => document.getElementById("item-carousel").clientWidth * factor;